import { render, staticRenderFns } from "./detail-optimized.vue?vue&type=template&id=592d506c&scoped=true&"
import script from "./detail-optimized.vue?vue&type=script&lang=ts&"
export * from "./detail-optimized.vue?vue&type=script&lang=ts&"
import style0 from "./detail-optimized.vue?vue&type=style&index=0&id=592d506c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d506c",
  null
  
)

export default component.exports